import type { ReadonlyDeep } from 'type-fest';

import { ReportInput } from '@e-socna/data-layer';

import { codingConfigForm2ApiMapper } from '../../../forms/CodingConfig/mappers/coding-config.form2api.mapper';
import { pruneInput } from '../../../utils/prune-input.util';
import { recursiveSectionForm2ApiMapper } from '../../../components/DocumentEditor/mappers/recursive-section.form2api.mapper';

import type { MissionReportPage_OneReport } from '../hooks/useFindOneReportQuery.hook';

export function reportForm2ApiMapper(
  report: ReadonlyDeep<MissionReportPage_OneReport>,
) {
  const reportInput = pruneInput(report, ReportInput);

  return {
    ...reportInput,
    virtualRoot: recursiveSectionForm2ApiMapper(report.virtualRoot),
    codingConfig: codingConfigForm2ApiMapper(report.codingConfig),
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    templateId: report.templateId || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    title: report.title || null,
  };
}
